import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import 'rxjs/Rx';
/*import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/fromEvent';*/
import {
  RequestOptions,
  Http,
  Headers,RequestMethod, ResponseContentType
} from "@angular/http";
import {ErrorService} from "../common/errors/error.service";
import {ResponseResult} from "../shared/ResponseResult";
import {Router} from "@angular/router";
import {ROUTE_CONSTANTS} from "../common/constant/RouteConstants";
import {RESPONSE_STATUS} from "../common/constant/ResponseStatus";
import {LoginService} from "./login.service";
import {LocalStorageService} from "./LocalStorage.service";
import {ApplicationService} from "./application.service";
import {CommonService} from "./common.service";
import {SpinnerService} from "../common/spinner/spinner.service";

@Injectable()
export class CustomHttpService {

    constructor(private _http : Http,
                private _errorService: ErrorService,
                private commonService : CommonService,
                private _spinnerService : SpinnerService,
                private router:Router) {
    }

    post(url: string,body : string): Observable<any> {
        let options : RequestOptions = this.getRequestOptions();
        console.debug('POST : ' + url);
        this._spinnerService.start();
        //noinspection TypeScriptValidateTypes
      return this._http.post(url,body,options)
            .map(response  => {
                  this._spinnerService.stop();
                  let responseResult  : ResponseResult<any> = <ResponseResult<any>>response.json();
                  if(response.headers.get('Authorization')!=null){
                    var token : string  = response.headers.get('Authorization');
                    this.commonService.setItem("Authorization",token);
                  }
                  if(responseResult.statusCode==RESPONSE_STATUS.INVALID_JWT_EXCEPTION){
                    this._errorService.showError("Session Expired.","Please Login.");
                    this.router.navigate([ROUTE_CONSTANTS.ROOT]);
                  }else if(responseResult.statusCode==RESPONSE_STATUS.INTERNAL_SERVER_ERROR ||
                    responseResult.statusCode==RESPONSE_STATUS.INVALID_PARAMETER_EXCEPTION){
                    this._errorService.showError("Something went wrong.","Please retry after sometime or contact Administrator.");
                  }

                  return responseResult;
                }
              )
            .catch((err) => {
                this._spinnerService.stop();

                console.log(err.status);

                if(err.status == 901) {
                  this.commonService.removeLoginDetail();
                  this.router.navigate([ROUTE_CONSTANTS.ROOT]);
                  this._errorService.showError("Your Session is Expired.","Please re-login from Application");
                } else {
                  this._errorService.showError("Something went wrong.","Please retry after sometime or contact Administrator.");
                }
                return Observable.throw(err);
            })
            .finally(() => {

            });
    }

    get(url: string): Observable<any> {
        let options : RequestOptions = this.getRequestOptions();
        console.debug('GET : ' + url);
        this._spinnerService.start();
        //noinspection TypeScriptValidateTypes
        return this._http.get(url,options)
            .map(response  => {
                this._spinnerService.stop();
                let responseResult  : ResponseResult<any> = <ResponseResult<any>>response.json();
                if(response.headers.get('Authorization')!=null){
                  var token : string  = response.headers.get('Authorization');
                  this.commonService.setItem("Authorization",token);
                }
                if(responseResult.statusCode==RESPONSE_STATUS.INVALID_JWT_EXCEPTION){
                  this._errorService.showError("Session Expired.","Please Login.");
                  this.router.navigate([ROUTE_CONSTANTS.ROOT]);
                }else if(responseResult.statusCode==RESPONSE_STATUS.INTERNAL_SERVER_ERROR ||
                  responseResult.statusCode==RESPONSE_STATUS.INVALID_PARAMETER_EXCEPTION){
                  this._errorService.showError("Something went wrong.","Please retry after sometime or contact Administrator.");
                }
                return responseResult;
              })
            .catch((err) => {
                this._spinnerService.stop();

              if(err.status == 901) {
                this.commonService.removeLoginDetail();
                this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
                this._errorService.showError("Your Session is Expired.","Please re-login from Application");
              } else {
                this._errorService.showError("Something went wrong.","Please retry after sometime or contact Administrator.");
              }
              return Observable.throw(err);
            })
            .finally(() => {

            });
    }

    getRequestOptions() : RequestOptions{
        let requestOptions: RequestOptions;
        let headers: Headers;
        headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
/*        let userId : string = this._localStorageService.getItem('userId','');
        if(userId!=''){
            headers.append('userId',userId);
        }*/
        let token : string = this.commonService.getItem('Authorization','');
        if(token!=''){
            headers.append('Authorization',token);
        }
        requestOptions = new RequestOptions({
            headers: headers
        });
        return requestOptions;
    }

  getBlobRequestOptions() : RequestOptions{
    let requestOptions: RequestOptions;
    let headers: Headers;
    headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    /*let userId : string = this.commonService.getItem('userId','');
    if(userId!=''){
      headers.append('userId',userId);
    }*/
    let token : string = this.commonService.getItem('Authorization','');
    if(token!=''){
      headers.append('Authorization',token);
    }
    requestOptions = new RequestOptions({
      headers: headers,
      method: RequestMethod.Post,
      responseType: ResponseContentType.Blob
    });
    return requestOptions;
  }

  postblob(url: string,body : string): Observable<any> {
    let options : RequestOptions = this.getBlobRequestOptions();
    console.debug('POST : ' + url);
    //this._spinnerService.start();
    return this._http.post(url,body,options);
  }x
}



// WEBPACK FOOTER //
// ./src/app/services/CustomHttp.service.ts